<template>
  <div class="echarts">
    <div style="width: 100%; height: 100%" :id="echarts" ref="echarts"></div>
  </div>
</template>

<script>
import "echarts/map/js/world";
export default {
  name: "echartscom",
  props: {
    options: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  methods: {
    drawCharts() {
      this.myChart = this.$echarts.init(document.getElementById(this.echarts));
      const other_options = {
        animation: false,
      };
      const all_options = Object.assign(other_options, this.options);
      this.myChart.setOption(this.options);
    },
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    },
  },
  mounted() {
    let self = this;
    self.$nextTick(() => {
      self.drawCharts();
    });
    window.addEventListener("resize", () => {
      self.myChart.resize();
    });
  },
  components: {},
  // watch: {
  //   //观察option的变化
  //   options: {
  //     handler(newVal, oldVal) {
  //       if (this.chart) {
  //         if (newVal) {
  //           this.chart.setOption(newVal);
  //         } else {
  //           this.chart.setOption(oldVal);
  //         }
  //       } else {
  //         this.drawCharts();
  //       }
  //     },
  //     deep: true, //对象内部属性的监听，关键。
  //   },
  // },
};
</script>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts.vue